import { GoogleOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Input } from 'antd';
import React from 'react';

import type { TLogin } from '@client/pages/auth/auth.page';

type TProps = {
  loading: boolean;
  handleLogin: (values: TLogin) => void;
  handleGoogleLogin: () => Promise<void>;
};

export const LoginSection: React.FC<TProps> = (props): React.JSX.Element => {
  const { loading, handleLogin, handleGoogleLogin } = props;

  return (
    <Form
      name="login"
      onFinish={handleLogin}
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please input your email!' },
          {
            type: 'email',
            message: 'Please enter a valid email address!',
          },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </Form.Item>
      <Form.Item
        name="password"
        label="Password"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.Password prefix={<LockOutlined />} placeholder="Password" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={loading}>
          Log In
        </Button>
      </Form.Item>
      <Divider>or</Divider>
      <Form.Item>
        <Button
          icon={<GoogleOutlined />}
          type="default"
          loading={loading}
          block
          onClick={handleGoogleLogin}
        >
          Continue with Google
        </Button>
      </Form.Item>
    </Form>
  );
};
